import Layout from "../../../components/layout/layout.js";

import PlayerProfileForm from "../../../components/form/player-profile.form";

function PlayerProfilePage({ component, ...rest }) {
  return <Layout Component={PlayerProfileForm} {...rest} controlsDisabled />;
}

export default PlayerProfilePage;
